const PLAY_TERM_DEFAULT_VALUE = 'Play'
const PLAY_TERM_REPLACEMNT = '$PlayTerm'
const PLAY_SENDER_REPLACEMNT = '$Sender'

export default class StaticReplacementProcessor {
  replacementsMap = new Map()

  constructor(playTerm, senderEmail) {
    this.replacementsMap.set(PLAY_TERM_REPLACEMNT, playTerm || PLAY_TERM_DEFAULT_VALUE)
    this.replacementsMap.set(PLAY_SENDER_REPLACEMNT, senderEmail)
  }

  process(template) {
    let result = template
    for (const [key, value] of this.replacementsMap) {
      if (value) {
        result = result.replaceAll(key, value)
      }
    }
    return result
  }
}
